import { buttonStyle, ICON_SLOT } from 'components/buttons/buttonStyle';
import { KeyboardDoubleArrowDown as KeyboardDoubleArrowDownIcon } from 'components/icons';
import { Button } from 'components/ui/button';
import { FC } from 'react';
import { cn } from 'utils/cn';
import { t } from 'utils/getTranslations';

type Props = {
    onClick: () => void;
    loading: boolean;
};

/**
 * While loading, the label is hidden rather than removed and the loading text sits over it, so the
 * button keeps its width.
 */
const LoadMoreButton: FC<Props> = ({ onClick, loading }) => (
    <div className="flex justify-center px-4 py-3.5">
        <Button {...buttonStyle({ variant: 'outlined' }, 'relative')} onClick={onClick} disabled={loading}>
            <span className={cn('inline-flex items-center gap-1.5', loading && 'invisible')}>
                <span className={ICON_SLOT.small}>
                    <KeyboardDoubleArrowDownIcon fontSize="small" />
                </span>
                {t('load-more')}
            </span>
            {loading ? <span className="absolute inset-0 flex items-center justify-center">{t('loading')}</span> : null}
        </Button>
    </div>
);

export default LoadMoreButton;
